import {
  AdminMenuTop,
  AdminNavigation,
  Pagination,
  SecureImage,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderItem,
  TableRow,
  TableWrapper,
  Text
} from '@components';
import { CategorySelectEnum, SexualPositionChildOptionValueEnum, styleConstant } from '@constant';
import { useIssueReport } from '@hooks';
import { colorSet } from '@theme';
import { getEnumKeyByValue } from '@utils';

// 어드민 - 접수된 오류 및 처리 완료 페이지, isOpenIssueReportListPage value에 의해 분기됨
const IssueReportListPage = () => {
  const { handleTableRowClick, isOpenIssueReportListPage, tableHeader, response, splitData, page, handlePageChange } =
    useIssueReport();

  return (
    <>
      <AdminMenuTop />

      <div style={{ display: 'flex' }}>
        <AdminNavigation />

        <div
          className="hide-scrollbar"
          style={{
            width: '100%',
            height: `calc(100vh - ${styleConstant.menuTopHeight}px)`,
            padding: '48px 40px 96px 40px',
            overflowY: 'auto'
          }}
        >
          <div
            style={{
              marginBottom: '40px'
            }}
          >
            <Text variant="h2" fontWeight="bold">
              {isOpenIssueReportListPage ? '접수된 오류' : '처리 완료'}
            </Text>
          </div>

          <TableWrapper width="100%">
            <Table width="100%">
              <TableHeader>
                {tableHeader.map((header, key) => (
                  <TableHeaderItem key={key} width={header.width}>
                    <Text color="white" fontWeight="bold" align="center">
                      {header.label}
                    </Text>
                  </TableHeaderItem>
                ))}
              </TableHeader>
              <div style={{ display: 'flex', borderBottom: `1px solid ${colorSet.gray300}` }}>
                <TableBody sx={{ width: '50%' }}>
                  {response?.data &&
                  response?.data.length > 0 &&
                  splitData(response?.data).leftPaneData &&
                  splitData(response?.data).leftPaneData.length > 0
                    ? splitData(response?.data).leftPaneData.map((row, key) => (
                        <TableRow
                          key={key}
                          onClick={() => {
                            handleTableRowClick(row.theme, row.imageId, row.sequenceId);
                          }}
                          height={124}
                          style={{ cursor: 'pointer' }}
                          hideBorderBottom={key === splitData(response?.data).leftPaneData.length - 1}
                          sx={{ borderRight: `1px solid ${colorSet.gray300}` }}
                        >
                          <TableCell width={tableHeader[0].width}>
                            <Text>{row.id}</Text>
                          </TableCell>
                          <TableCell width={tableHeader[1].width} padding="8px 12px">
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <div
                                style={{
                                  width: 60,
                                  height: 80,
                                  border: `1px solid ${colorSet.gray300}`,
                                  borderRadius: '3px',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  marginRight: '12px'
                                }}
                              >
                                <SecureImage
                                  imageUrl={row.s3Url ?? ''}
                                  imageStyle={{ width: 52, height: 72, objectFit: 'cover' }}
                                />
                              </div>
                              <div
                                style={{
                                  width: tableHeader[1].width - 96,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: '4px'
                                }}
                              >
                                <Text
                                  align="left"
                                  style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    width: '100%'
                                  }}
                                >
                                  {row.originFileName}
                                </Text>
                                <Text
                                  align="left"
                                  style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    width: '100%'
                                  }}
                                >
                                  테마: {CategorySelectEnum[row.theme]}
                                </Text>
                                <Text
                                  align="left"
                                  style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    width: '100%'
                                  }}
                                >
                                  장르: {row.genre}
                                </Text>
                                {row.position ? (
                                  <Text
                                    align="left"
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      width: '100%'
                                    }}
                                  >
                                    체위:{' '}
                                    {(() => {
                                      return getEnumKeyByValue(SexualPositionChildOptionValueEnum, row.position);
                                    })()}
                                  </Text>
                                ) : null}
                              </div>
                            </div>
                          </TableCell>
                          <TableCell width={tableHeader[2].width} justifyContent="flex-start">
                            <Text
                              style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: '4',
                                WebkitBoxOrient: 'vertical',
                                wordBreak: 'break-all'
                              }}
                            >
                              {row.reportContent}
                            </Text>
                          </TableCell>
                        </TableRow>
                      ))
                    : null}
                </TableBody>
                <TableBody sx={{ width: '50%' }}>
                  {response?.data &&
                  response?.data.length > 0 &&
                  splitData(response?.data).rightPaneData &&
                  splitData(response?.data).rightPaneData.length > 0
                    ? splitData(response?.data).rightPaneData.map((row, key) => (
                        <TableRow
                          key={key}
                          onClick={() => {
                            handleTableRowClick(row.theme, row.imageId, row.sequenceId);
                          }}
                          height={124}
                          style={{ cursor: 'pointer' }}
                          hideBorderBottom={key === splitData(response?.data).leftPaneData.length - 1}
                        >
                          <TableCell width={tableHeader[0].width}>
                            <Text>{row.id}</Text>
                          </TableCell>
                          <TableCell width={tableHeader[1].width} padding="8px 12px">
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <div
                                style={{
                                  width: 60,
                                  height: 80,
                                  border: `1px solid ${colorSet.gray300}`,
                                  borderRadius: '3px',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  marginRight: '12px'
                                }}
                              >
                                <SecureImage
                                  imageUrl={row.s3Url ?? ''}
                                  imageStyle={{ width: 52, height: 72, objectFit: 'cover' }}
                                />
                              </div>
                              <div
                                style={{
                                  width: tableHeader[1].width - 96,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: '4px'
                                }}
                              >
                                <Text
                                  align="left"
                                  style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    width: '100%'
                                  }}
                                >
                                  {row.originFileName}
                                </Text>
                                <Text
                                  align="left"
                                  style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    width: '100%'
                                  }}
                                >
                                  테마: {CategorySelectEnum[row.theme]}
                                </Text>
                                <Text
                                  align="left"
                                  style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    width: '100%'
                                  }}
                                >
                                  장르: {row.genre}
                                </Text>
                                {row.position ? (
                                  <Text
                                    align="left"
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      width: '100%'
                                    }}
                                  >
                                    체위:{' '}
                                    {(() => {
                                      return getEnumKeyByValue(SexualPositionChildOptionValueEnum, row.position);
                                    })()}
                                  </Text>
                                ) : null}
                              </div>
                            </div>
                          </TableCell>
                          <TableCell width={tableHeader[2].width} justifyContent="flex-start">
                            <Text
                              style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: '4',
                                WebkitBoxOrient: 'vertical',
                                wordBreak: 'break-all'
                              }}
                            >
                              {row.reportContent}
                            </Text>
                          </TableCell>
                        </TableRow>
                      ))
                    : null}
                </TableBody>
              </div>
            </Table>
          </TableWrapper>

          <div
            style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end' }}
          >
            <div style={{ display: 'flex', flexDirection: 'row', gap: 8, alignItems: 'center' }}>
              <Text variant="body1">Total</Text>
              <Text variant="subtitle" fontWeight="bold">
                {response?.meta?.itemCount ?? 0}
              </Text>
            </div>
            <Pagination page={page} pageCount={response?.meta?.pageCount ?? 0} onChange={handlePageChange} />
          </div>
        </div>
      </div>
    </>
  );
};

export default IssueReportListPage;
